export default __webpack_public_path__ + "static/media/qAderApp.a792aeee.PNG";